import { AppInfoLoader } from '@services/AppInfoLoader';
import { CountMetric } from '@src/metrics/CountMetric';

/**
 * StoreFamilyService module can be used to identify specific store format.
 */
export class StoreFamilyService {
    private static IN_MWHS_TAG = 'CAP_HWMS';
    private static AUKF_TAG = 'CAP_AUKF';
    private static AFS_TAG = 'CAP_AFS';
    private static RFID_TAG = 'CAP_RFID_GATEPOD';
    // Allowlisting Urban-Test-GRA1 marketplaceId for testing Serenity and Bananastand changes in Beta
    private static URBAN_TEST_GRA1 = 'A332POBM3AVU51';
    private static IN_MARKETPLACE_ID_LIST = ['A2XZLSVIQ0F4JT', 'A21TJRUUN4KGV', this.URBAN_TEST_GRA1];
    private static MENA_QC_HWMS_TAG = 'CAP_MENA_QC_HWMS';
    private static MENA_MARKETPLACE_ID_LIST = ['A34GYYCZVDBSIK', 'A2VIGQ35RCS4UG', 'A1MQPSGJ6U9Q54', 'A17E79C6D8DWNP', 'AUJPM9XGFJRC7', 'ARBP9OOSHTCHU'];
    /**
     * @return boolean indicating if this store is an IN HWMS store or not.
     */
    public static async isINHWMSStore() {
        try {
            const storeInfo = await StoreFamilyService.getStoreInfo();
            const marketplaceId = storeInfo.marketplaceId;
            if (this.IN_MARKETPLACE_ID_LIST.includes(marketplaceId)) {
                const tags = storeInfo.tags;
                return tags && tags.includes(this.IN_MWHS_TAG);
            }
            return false;
        } catch (error) {
            console.error('Unable to get storeInfo, default to isInHWMSStore: false');
            return false;
        }
    }
    /**
     * @return boolean indicating if this store is a MENA QC HWMS store or not.
     */
    public static async isMENAQCStore() {
        try {
            const storeInfo = await StoreFamilyService.getStoreInfo();
            const marketplaceId = storeInfo.marketplaceId;
            if (this.MENA_MARKETPLACE_ID_LIST.includes(marketplaceId)) {
                const tags = storeInfo.tags;
                return tags && tags.includes(this.MENA_QC_HWMS_TAG);
            }
            return false;
        } catch (error) {
            console.error('Unable to get storeInfo, default to isMENAQCStore: false');
            return false;
        }
    }

    /**
     * @return boolean indicating if this store is an AUKF store or not.
     */
    public static async isAUKFStore() {
        try {
            const storeInfo = await StoreFamilyService.getStoreInfo();
            const tags = storeInfo.tags;
            return tags && tags.includes(this.AUKF_TAG);
        } catch (error) {
            console.error('Unable to get storeInfo, default to isAUKFStore: false');
            return false;
        }
    }

    /**
     * @return boolean indicating if this store is an AFS store or not.
     */
    public static async isAFSStore() {
        try {
            const storeInfo = await StoreFamilyService.getStoreInfo();
            const tags = storeInfo.tags;
            return tags && tags.includes(this.AFS_TAG);
        } catch (error) {
            console.error('Unable to get storeInfo, default to isAFSStore: false');
            return false;
        }
    }

    /**
     * @return boolean indicating if this store is an RFID store or not.
     */
    public static async isRFIDStore() {
        try {
            const storeInfo = await StoreFamilyService.getStoreInfo();
            const tags = storeInfo.tags;
            return tags && tags.includes(this.RFID_TAG);
        } catch (error) {
            console.error('Unable to get storeInfo, default to isRFIDStore: false');
            return false;
        }
    }

    /**
     * Returns store info from app config.
     *
     * @return Store info.
     */
    public static async getStoreInfo() {
        let faultmetric;
        try {
            const appConfig = await AppInfoLoader.getAppConfig();
            faultmetric = new CountMetric(appConfig.store, 'Fault', 'IhmFlyingDutchman', 'StoreFamilyService.getStoreInfo');
            faultmetric.count(0);
            return appConfig.storeInfo;
        } catch (error) {
            if (!faultmetric) {
                faultmetric = new CountMetric('unknown', 'Fault', 'IhmFlyingDutchman', 'StoreFamilyService.getStoreInfo');
            }
            faultmetric.count(1);
            console.error('Error Detected when calling getStoreInfo', error);
            return Promise.reject(error);
        }
    }
}
